export default __webpack_public_path__ + "static/06.06_Partners_logo_320-79f1cf2ea79ed9acfc313075b68b9afb.png";